import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing, typography }) => ({
  listItemText: {
    whiteSpace: 'nowrap',
  },
  icon: {
    marginLeft: spacing(),
  },
  arrowIcon: {
    position: 'relative',
    top: spacing(0.25),
  },
  chip: {
    backgroundColor: '#fff',
    fontSize: typography.pxToRem(11),
  },
}));
